import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from 'components/common/FormElements/Checkbox/Checkbox'

const CONTROL_LABEL = 'None'

const ResetControl = ({ active, onReset, ...props }) =>
  <Checkbox
    { ...props }
    margin="0 0 17px 0"
    label={ CONTROL_LABEL }
    value={ active }
    onChange={ onReset } />

export default ResetControl

ResetControl.propTypes = {
  active: PropTypes.bool,
  onReset: PropTypes.func
}
